export const billingOptions = ['Monthly', 'Quarterly', 'Yearly']

export const allPlans = [
  {
    title: 'Test Plan (1 Day)',
    price: {
      monthly: '$0.01',
      quarterly: '$0.01',
      yearly: '$0.01'
    },
    saveUpTo: {
      quarterly: '-',
      yearly: '-'
    },
    features: [
      '⚠️ TESTING ONLY - 1 Day Billing Cycle',
      '1 Adult account',
      'All Premium Features',
      'For development & testing purposes',
      'Not for production use'
    ],
    key: 'test',
    testOnly: true
  },
  {
    title: 'Free with ads',
    price: {
      monthly: '$0.00',
      quarterly: '$0.00',
      yearly: '$0.00'
    },
    saveUpTo: {
      quarterly: '-',
      yearly: '-'
    },
    features: [
      '1 Adult account',
      'Unlimited Canvas',
      'Basic Budget Management',
      'Dashboard widgets (with ads)',
      'Includes ads'
    ],
    key: 'free'
  },
  {
    title: 'Premium',
    price: {
      monthly: '$4.49',
      quarterly: '$11.45',
      yearly: '$37.72'
    },
    saveUpTo: {
      quarterly: 'Save up to $2.02',
      yearly: 'Save up to $16.16'
    },
    features: [
      '1 Adult account',
      'Unlimited Canvas',
      'Advanced Budget Tools',
      'Investment & Mortgage Tracking',
      'Ad-free Experience'
    ],
    key: 'single'
  },
  {
    title: 'Premium Duo',
    price: {
      monthly: '$6.74',
      quarterly: '$17.17',
      yearly: '$56.57'
    },
    saveUpTo: {
      quarterly: 'Save up to $3.03',
      yearly: 'Save up to $24.25'
    },
    features: [
      '2 Adult accounts',
      'Shared Canvas',
      'Advanced Budget Tools',
      'Investment & Mortgage Tracking',
      'Ad-free Experience'
    ],
    key: 'duo'
  },
  {
    title: 'Family Premium',
    price: {
      monthly: '$14.59',
      quarterly: '$37.21',
      yearly: '$122.58'
    },
    saveUpTo: {
      quarterly: 'Save up to $6.57',
      yearly: 'Save up to $52.53'
    },
    features: [
      '4 Adult & Unlimited Kids accounts',
      'Shared Family Canvas',
      'Advanced Budget Tools',
      'Investment & Mortgage Tracking',
      'Ad-free Experience'
    ],
    key: 'family'
  }
];